import { useEffect, useState, useCallback } from "react";
import {
  fetchSuppliersForAdmin,
  saveSuppliersToApi,
} from "../../utils/contentApi";
import "./suppliersAdmin.css";

function SuppliersAdmin() {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [newName, setNewName] = useState("");
  const [newRestaurant, setNewRestaurant] = useState("Carpe Diem");

  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      setMessage("");
      const data = await fetchSuppliersForAdmin();
      setSuppliers(data);
    } catch {
      setMessage("Erreur lors du chargement des fournisseurs.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const addSupplier = () => {
    const name = String(newName || "").trim();
    const restaurant = String(newRestaurant || "").trim() || "Carpe Diem";
    if (!name) return;

    setSuppliers((prev) => {
      const exists = prev.some(
        (item) => String(item.name || "").toLowerCase() === name.toLowerCase(),
      );
      if (exists) {
        return prev;
      }

      return [
        ...prev,
        {
          id: `supplier-${Date.now()}`,
          name,
          restaurant,
          updatedAt: new Date().toISOString(),
        },
      ];
    });

    setNewName("");
    setNewRestaurant("Carpe Diem");
  };

  const removeSupplier = (id) => {
    setSuppliers((prev) => prev.filter((item) => item.id !== id));
  };

  const updateSupplier = (id, field, value) => {
    setSuppliers((prev) =>
      prev.map((item) => (item.id === id ? { ...item, [field]: value } : item)),
    );
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setMessage("");
      const saved = await saveSuppliersToApi(suppliers);
      setSuppliers(saved);
      setMessage("Liste des fournisseurs sauvegardée.");
      setTimeout(() => setMessage(""), 3000);
    } catch {
      setMessage("Erreur lors de la sauvegarde des fournisseurs.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="suppliers-admin">
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="suppliers-admin">
      <div className="suppliers-admin-header">
        <h2>Gestion des fournisseurs</h2>
        <p>Ajoutez ici la liste des fournisseurs partenaires du restaurant.</p>
      </div>

      {message ? (
        <div
          className={`suppliers-admin-message${message.includes("Erreur") ? " error" : " success"}`}
        >
          {message}
        </div>
      ) : null}

      <div className="suppliers-admin-add-row">
        <input
          type="text"
          placeholder="Nom du fournisseur"
          value={newName}
          onChange={(event) => setNewName(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && addSupplier()}
        />
        <input
          type="text"
          placeholder="Restaurant"
          value={newRestaurant}
          onChange={(event) => setNewRestaurant(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && addSupplier()}
        />
        <button type="button" onClick={addSupplier} disabled={!newName.trim()}>
          + Ajouter
        </button>
      </div>

      <div className="suppliers-admin-table-wrap">
        <table className="suppliers-admin-table">
          <thead>
            <tr>
              <th>Fournisseur</th>
              <th>Restaurant</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {suppliers.length ? (
              suppliers.map((item) => (
                <tr key={item.id}>
                  <td>
                    <input
                      type="text"
                      value={item.name || ""}
                      onChange={(event) =>
                        updateSupplier(item.id, "name", event.target.value)
                      }
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      value={item.restaurant || "Carpe Diem"}
                      onChange={(event) =>
                        updateSupplier(item.id, "restaurant", event.target.value)
                      }
                    />
                  </td>
                  <td>
                    <button
                      type="button"
                      className="danger"
                      onClick={() => removeSupplier(item.id)}
                    >
                      Supprimer
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="empty">
                  Aucun fournisseur. Ajoutez votre première entrée.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="suppliers-admin-save-row">
        <button type="button" onClick={handleSave} disabled={saving}>
          {saving ? "Sauvegarde..." : "Sauvegarder"}
        </button>
      </div>
    </div>
  );
}

export default SuppliersAdmin;
